import { useDispatch } from 'react-redux';
import Router from 'next/router';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';

import { updateClientInfo } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actions';

const ConnectionPaid = (): JSX.Element => {
    const dispatch = useDispatch();

    const onClose = () => {
        dispatch(updateClientInfo());
        Router.push('/lk');
    };

    return (
        <ButtonGroup>
            <Button onClick={onClose}>Закрыть</Button>
        </ButtonGroup>
    );
};

export default ConnectionPaid;
